// The Vue build-script version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'typeface-roboto'
import App from './App'
import router from './router'
import i18n from './lang/i18n'
import store from './store/store'
import VueResource from 'vue-resource'
import Vuelidate from 'vuelidate'
import Gravatar from 'vue-gravatar'
import ArgonDashboard from '@/plugins/argon-dashboard'
import VueClipboard from 'vue-clipboard2'

import Notifications from 'vue-notification'

import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import { BootstrapVue } from 'bootstrap-vue'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import './assets/css/main.css'
import baseServerAxios from './services/axios-instance-provider'

Vue.use(Notifications)

Vue.component('v-gravatar', Gravatar)

Vue.config.productionTip = false
Vue.use(ArgonDashboard)

// Vue.use(BootstrapVue)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(VueResource)
Vue.use(Vuelidate)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// Handling keycloak
const tokenInterception = () => {
  baseServerAxios.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
    return config
  }, error => {
    return Promise.reject(error)
  })
}
Vue.use(VueKeyCloak, {
  init: {
    onLoad: 'login-required',
    checkLoginIframe: false
  },
  config: {
    url: process.env.KEYCLOAK_LOCUST_AUTH_SERVER_URL,
    clientId: process.env.KEYCLOAK_CLIENT_ID,
    realm: process.env.KEYCLOAK_REALM
  },
  onReady: () => {
    tokenInterception()
    // eslint-disable-next-line
    new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>',
      i18n,
      store
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js